/*
 * Collapsable Content Module
 */
// jQuery(document).ready(function($) {
//     $('.collapsable_content dt').click(function(e) {
//         console.log('Click');
//         e.preventDefault();
//         var t = $(this);
//         t.toggleClass('collapsed');

//         setMaxHeight();
//     });

//     setMaxHeight();

//     $('.collapsable_content dt').each(function(index, el) {
//         if(index!==0) $(el).addClass('collapsed no-transition');
//     });

//     window.setTimeout(function(){
//         $('.collapsable_content dt').each(function(index, el) {
//             if(index!==0) $(el).removeClass('no-transition');
//         });
//     }, 400);

//     function setMaxHeight(){
//         $('.collapsable_content dd').each(function(index, el) {
//             if($(el).outerHeight() !== 0) $(el).css('max-height', $(el).outerHeight(true));
//         });
//     }

//     $(window).resize(function() {
//         setMaxHeight();
//     });
// });;

const accordionHeaders = document.querySelectorAll('[data-accordion-header]');

Array.prototype.forEach.call(accordionHeaders, accordionHeader => {
    let target = accordionHeader.parentElement.nextElementSibling;

    accordionHeader.onclick = () => {
        let expanded = accordionHeader.getAttribute('aria-expanded') === 'true' || false;
        accordionHeader.setAttribute('aria-expanded', !expanded);
        target.hidden = expanded;
    }
})